import { useState, useEffect } from 'react'

interface SearchInputProps {
  placeholder?: string
  value?: string
  onChange?: (value: string) => void
  onSearch?: (value: string) => void
  className?: string
}

const SearchInput = ({ 
  placeholder = 'Search...', 
  value, 
  onChange, 
  onSearch,
  className = '' 
}: SearchInputProps) => {
  const [searchTerm, setSearchTerm] = useState(value || '')

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onSearch?.(searchTerm)
    }, 500) // Debounce search

    return () => clearTimeout(timeoutId)
  }, [searchTerm, onSearch])

  const handleChange = (newValue: string) => {
    setSearchTerm(newValue)
    onChange?.(newValue)
  }

  return (
    <div className={`relative ${className}`}>
      <input 
        type='text' 
        value={searchTerm}
        onChange={(e) => handleChange(e.target.value)}
        className='outline-none border-[1px] h-[46px] rounded-[10px] border-[#7C797C] text-muted-foreground pl-10 w-full' 
        placeholder={placeholder}
      />
      <svg 
        width="20" 
        height="20" 
        viewBox="0 0 20 20" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg" 
        className="absolute left-3 top-1/2 transform -translate-y-1/2"
      >
        <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#7C797C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17.5 17.5L13.875 13.875" stroke="#7C797C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  )
}

export default SearchInput